import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, AutoComplete, Input, Button } from "antd";
import { Link } from "react-router-dom";

export default function WebHooksMP() {
  const [webhooks, setWebhooks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const [searchValue, setSearchValue] = useState("");
  const [options, setOptions] = useState([]);
  const [filtered, setFiltered] = useState([]);

  const fetchWebhooks = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await axios.get(
        "https://gestor.bebilogo.com.br/api-mercadopago/webhooks/list"
      );
      setWebhooks(response.data);
      setFiltered(response.data);
    } catch (err) {
      console.error("Erro ao carregar webhooks:", err);
      setError("Erro ao carregar webhooks. Tente novamente mais tarde.");
      setWebhooks([]);
      setFiltered([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWebhooks();
    const interval = setInterval(fetchWebhooks, 5000);
    return () => clearInterval(interval);
  }, []);

  const formatCurrency = (value) =>
    value
      ? Number(value).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
      : "-";

  const handleSearch = (value) => {
    setSearchValue(value);
    if (!value) {
      setOptions([]);
      setFiltered(webhooks);
      return;
    }

    const filteredOptions = webhooks
      .map((wh) => {
        let parsed = {};
        try {
          parsed = wh.data ? JSON.parse(wh.data) : {};
        } catch {
          parsed = {};
        }
        const paymentId = parsed.id?.toString() || "";
        const usuario = parsed.payer?.email || "";
        return {
          value: paymentId || usuario || "",
          label: paymentId ? `Pedido: ${paymentId}` : usuario ? `Usuário: ${usuario}` : "",
        };
      })
      .filter((opt) => opt.value.includes(value));

    setOptions(filteredOptions);
  };

  const onSelect = (value) => {
    setSearchValue(value);
    const newData = webhooks.filter((wh) => {
      try {
        const parsed = wh.data ? JSON.parse(wh.data) : {};
        return parsed.id?.toString().includes(value) || parsed.payer?.email?.includes(value);
      } catch {
        return false;
      }
    });
    setFiltered(newData);
  };

  const columns = [
    { title: "ID Webhook", dataIndex: "id", key: "id", width: 120 },
    { title: "Tipo", dataIndex: "type", key: "type", width: 100 },
    { title: "Ação", dataIndex: "action", key: "action", width: 120 },
    {
      title: "ID Pagamento",
      key: "paymentId",
      render: (record) => {
        try {
          const parsed = record.data ? JSON.parse(record.data) : {};
          return parsed.id || "-";
        } catch {
          return "-";
        }
      },
    },
    {
      title: "Status",
      key: "status",
      render: (record) => {
        try {
          const parsed = record.data ? JSON.parse(record.data) : {};
          return parsed.status || record.status || "-";
        } catch {
          return record.status || "-";
        }
      },
    },
    {
      title: "Tipo de Pagamento",
      key: "paymentType",
      render: (record) => {
        try {
          const parsed = record.data ? JSON.parse(record.data) : {};
          return parsed.payment_type_id || "-";
        } catch {
          return "-";
        }
      },
    },
    {
      title: "Cartão",
      key: "card",
      render: (record) => {
        try {
          const parsed = record.data ? JSON.parse(record.data) : {};
          if (parsed.payment_type_id?.includes("card")) {
            return `${parsed.card?.brand || "-"} ****${parsed.card?.last_four_digits || "-"}`;
          }
          return "-";
        } catch {
          return "-";
        }
      },
    },
    {
      title: "Valor",
      key: "amount",
      render: (record) => {
        try {
          const parsed = record.data ? JSON.parse(record.data) : {};
          return formatCurrency(parsed.transaction_amount);
        } catch {
          return "-";
        }
      },
    },
    {
      title: "Criado em",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (val) => (val ? new Date(val).toLocaleString() : "-"),
    },
  ];

  return (
    <div style={{ padding: "70px 20px" }}>
      <h2>Webhooks Mercado Pago</h2>

      {/* Linha de busca + botão */}
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: 20 }}>
        <AutoComplete
          popupMatchSelectWidth={252}
          style={{ width: 300 }}
          value={searchValue}
          options={options}
          onSelect={onSelect}
          onSearch={handleSearch}
          size="large"
        >
          <Input.Search size="large" placeholder="Buscar por Pedido ou Usuário" enterButton />
        </AutoComplete>

        <Link to="/mppayments">
          <Button type="primary" size="large">
            Pagamentos
          </Button>
        </Link>
      </div>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <Table
        rowKey="id"
        columns={columns}
        size="small"
        dataSource={filtered}
        loading={loading}
        pagination={{ pageSize: 10 }}
        expandable={{
          expandedRowRender: (record) => {
            let parsed = {};
            try {
              parsed = record.data ? JSON.parse(record.data) : {};
            } catch {
              parsed = { raw: record.data };
            }
            return (
              <pre
                style={{
                  background: "#f0f0f0",
                  padding: "10px",
                  borderRadius: "5px",
                  overflowX: "auto",
                  marginTop: "10px",
                }}
              >
                {JSON.stringify(parsed, null, 2)}
              </pre>
            );
          },
          expandedRowKeys,
          onExpand: (expanded, record) => {
            setExpandedRowKeys(expanded ? [record.id] : []);
          },
        }}
        scroll={{ x: "max-content" }}
        onRow={(record) => ({
          onClick: () => {
            const isExpanded = expandedRowKeys.includes(record.id);
            setExpandedRowKeys(isExpanded ? [] : [record.id]);
          },
          style: { cursor: "pointer" },
        })}
      />
    </div>
  );
}
